import { ReactElement } from "react";
import { Recommendation } from "@financial-advisory/data-access/api-types";

export enum MessageType {
  Text = "text",
  Question = "question",
  Explanation = "explanation",
}

export enum MessageAuthor {
  Bot = "assistant",
  User = "user",
  Auditor = "auditor",
  System = "system",
  Feedback = "feedback",
  Debug = "debug",
}

export function fromName(str: string): MessageAuthor {
  switch (str) {
    case "assistant":
      return MessageAuthor.Bot;
    case "user":
      return MessageAuthor.User;
    case "auditor":
      return MessageAuthor.Auditor;
    case "system":
      return MessageAuthor.System;
    case "feedback":
      return MessageAuthor.Feedback;
    case "debug":
      return MessageAuthor.Debug;
  }
  throw Error("unrecognised message author");
}

export type Message = {
  id: string;
  author: MessageAuthor;
  profileImageUrl?: string;
  type: MessageType;
  recommendation?: Recommendation;
  question?: string;
  text?: string | ReactElement;
  sentAt: string;
  widget?: ReactElement | null;
};

export type PushMessage = Omit<Message, "id" | "type" | "sentAt">;
export type UpdateMessage = Omit<
  Message,
  "type" | "sentAt" | "author" | "profileImageUrl" | "minTypingTimeMs"
>;
